import React, { useState, useEffect, useRef } from 'react'
import { useAlert } from 'react-alert'
import Home from '../../../presentation/pages/home'
import FirstStep from '../../../presentation/components/firstStep'
import SecondStep from '../../../presentation/components/secondStep'
import ThirdStep from '../../../presentation/components/thirdStep'
import { makeFinalizeResult } from '../../usecases/finalize-result/finalize-result'
import { makeSaveUserData } from '../../usecases/save-user-data/save-user-data'

type DataProps={
  filtroDoConstruto:string
    tipoDeTeste:string
    tipoDeTabela: string,
    escolaridade?: string,
    sexo?: string,
    idade?: string,
    pontuação: string,
  }
type UserDataProps={
  teste: {
    cdTeste: number,
    nome: string,
  },
  tipoTabela: {
    cdTipoTabela: number,
    descricao: string,
  },
  pontuacao: number,
  parametro: string,
  tabelaDados: {
    classificacao: undefined,
    percentil: undefined,
  },
  resumo: string,
}
const HomeFactory = () => {
  const dataInitialSetter = (storage:string | null):DataProps => {
    if (storage !== null) {
      return (JSON.parse(localStorage.getItem('currentData') || ''))
    }
    return ({
      filtroDoConstruto: ' ',
      tipoDeTeste: ' ',
      tipoDeTabela: ' ',
      escolaridade: undefined,
      sexo: undefined,
      idade: undefined,
      pontuação: ' ',
    })
  }
  const userDataInitialSetter = (storage:string | null):UserDataProps => {
    if (storage !== null) {
      return (JSON.parse(localStorage.getItem('currentUserData') || ''))
    }
    return ({
      teste: {
        cdTeste: 0,
        nome: '',
      },
      tipoTabela: {
        cdTipoTabela: 0,
        descricao: '',
      },
      pontuacao: 0,
      parametro: '',
      tabelaDados: {
        classificacao: undefined,
        percentil: undefined,
      },
      resumo: '',
    })
  }
  const [step, setStep] = useState(parseInt(localStorage.getItem('currentStep') || '0', 10))
  const [data, setData] = useState<DataProps>(dataInitialSetter(localStorage.getItem('currentData')))
  const tawkMessengerRef = useRef()
  const [userData, setUserData] = useState({
    nome: '',
    email: '',
    telefone: '',
    comentarios: null,

  })
  const [finalResults, setFinalResults] = useState(userDataInitialSetter(localStorage.getItem('currentUserData')))
  useEffect(() => {
    localStorage.setItem('currentData', JSON.stringify(data))
    localStorage.setItem('currentStep', step.toString())
  }, [step, data])

  const alert = useAlert()
  const [startModal, setStartModal] = useState(true)
  const [arrowsFill, setarrowsFill] = useState(['gray', 'gray'])
  const [stepsIconsFill, setStepsIconsFill] = useState(['#00995D', '#C2C2C2', '#C2C2C2'])
  const [testType, setTestType] = useState(0)
  const verifyParameter = () => {
    if (data.escolaridade) {
      return data.escolaridade.replace('é', 'e')
    }
    if (data.sexo) {
      return data.sexo
    }
    if (data.idade) { return (data.idade) }
    return ' '
  }
  const handleStepChange = () => {
    switch (step) {
      default: {
        setarrowsFill(['black', 'gray'])
        setStepsIconsFill(['#00995D', '#C2C2C2', '#C2C2C2'])
        break }
      case 0: {
        switch (data.tipoDeTabela.toString()) {
          case '1': {
            setTestType(2)
            setStep((prev: number) => (prev + 1))

            break
          }
          case '2': {
            setTestType(1)
            setStep((prev: number) => (prev + 1))
            break
          }
          case '3': {
            setTestType(0)
            setStep((prev: number) => (prev + 1))

            break
          }
          default: {
            alert.show('Tabela inválida')
            break
          }
        }
        setarrowsFill(['black', 'gray'])
        setStepsIconsFill(['#00995D', '#00995D', '#C2C2C2'])
        break }
      case 1:
      { setarrowsFill(['black', 'black'])
        setStepsIconsFill(['#00995D', '#00995D', '#00995D'])
        setStep((prev: number) => (prev + 1))
        break }
    }
  }

  const getResults = async () => {
    try {
      const finalResult = await makeFinalizeResult(
        data.tipoDeTeste,
        data.tipoDeTabela,
        verifyParameter(),
        data.pontuação,
      ).post()
      localStorage.setItem('currentUserData', JSON.stringify(finalResult))
      setFinalResults(finalResult)
      handleStepChange()
    } catch (error) {
      alert.show('Dados inválidos')
    }
  }

  const pages = [
    <FirstStep
      handleClick={() => {
        handleStepChange()
      }}
      data={data}
      setData={setData}
    />,
    <SecondStep
      handleClick={() => {
        getResults()
      }}
      data={data}
      setData={setData}
      testType={testType}
    />,
    <ThirdStep
      userData={userData}
      setUserData={setUserData}
      handleClick={async () => makeSaveUserData().post(userData)}
      classificacao={finalResults.tabelaDados
        ? finalResults.tabelaDados.classificacao : undefined}
      percentil={finalResults.tabelaDados
        ? finalResults.tabelaDados.percentil : undefined}
      teste={finalResults.teste.nome}
      pontuacao={finalResults.pontuacao.toString()}
      tabela={finalResults.tipoTabela.descricao}
      parametro={finalResults.parametro}
    />]
  return (
    <Home
      isThirdStep={step === 2}
      startModal={startModal}
      setStartModal={setStartModal}
      tawkRef={tawkMessengerRef}
      stepsIconsFill={stepsIconsFill}
      arrowsfill={arrowsFill}
      step={step}
      pages={pages}
    />
  )
}
export default HomeFactory
